export default {
  methods: {
    // { "responseWallsCeilingFloorHeatTransfer": 1.453, "responseHeatTransmission": 10.98, "responseHeatRadiation": 7.04, "responseHeatDevices": 40, "responseFreshAirHeatGain": 0.22, "responseAirFlowInfiltration": 29.83, "responseCondensateWater": 0.11, "responseHeatCalculated": 58.24, "responseTotalHeatGain": 64.07, "responseAdditionalHumidityRequired": 27.01, "responseSafetyFactor": 10, "responseAirFlow": 0, "createdDate": "2025-02-19T15:00:07.235514", "updatedDate": "2025-02-19T15:00:07.235585", "isActive": true }
    getExcelFields() {
      return {
        // Başlık
        [this.$t("ehouseDoubleCalculating.title")]: {
          field: "title",
          callback: (value) => {
            return value;
          },
        },

        // Form Alanları - Ambient Conditions
        [this.$t("ehouseDoubleCalculating.altitudeLocation")]: {
          field: "altitudeLocation",
          callback: (value) => {
            return value + " m";
          },
        },
        [this.$t("ehouseDoubleCalculating.ambientPressure")]: {
          field: "ambientPressure",
          callback: (value) => {
            return value + " kPa";
          },
        },
        [this.$t("ehouseDoubleCalculating.ambientTemperature")]: {
          field: "ambientTemperature",
          callback: (value) => {
            return value + " °C";
          },
        },
        [this.$t("ehouseDoubleCalculating.ambientRelativeHumidity")]: {
          field: "ambientRelativeHumidity",
          callback: (value) => {
            return value + " %";
          },
        },
        [this.$t("ehouseDoubleCalculating.radiationPower")]: {
          field: "solarRaditionPowerSquareMeter",
          callback: (value) => {
            return value + " W/m²";
          },
        },

        // Alanları - Main Room Air Conditions
        [this.$t("ehouseDoubleCalculating.airTemperature")]: {
          field: "airTemperature",
          callback: (value) => {
            return value + " °C";
          },
        },
        [this.$t("ehouseDoubleCalculating.airRelativeHumidity")]: {
          field: "airRelativeHumidity",
          callback: (value) => {
            return value + " %";
          },
        },
        [this.$t("ehouseDoubleCalculating.heatGeneration")]: {
          field: "heatGeneration",
          callback: (value) => {
            return value + " kW";
          },
        },
        [this.$t("ehouseDoubleCalculating.pressurazingPressure")]: {
          field: "pressurazingPressure",
          callback: (value) => {
            return value + " Pa";
          },
        },
        [this.$t("ehouseDoubleCalculating.requiredPressurization")]: {
          field: "requiredPressurazing",
          callback: (value) => {
            return value + " Pa";
          },
        },

        // Alanları - Auxiliary Room Air Conditions
        [this.$t("ehouseDoubleCalculating.coolledAirRatio")]: {
          field: "coolledAirRatio",
          callback: (value) => {
            return value + " %";
          },
        },
        [this.$t("ehouseDoubleCalculating.auxiliaryHeatGeneration")]: {
          field: "auxiliaryHeatGeneration",
          callback: (value) => {
            return value + " kW";
          },
        },

        // Alanları - Geometric Parameters (Main Room)
        [this.$t("ehouseDoubleCalculating.length")]: {
          field: "length",
          callback: (value) => {
            return value + " mm";
          },
        },
        [this.$t("ehouseDoubleCalculating.width")]: {
          field: "width",
          callback: (value) => {
            return value + " mm";
          },
        },
        [this.$t("ehouseDoubleCalculating.height")]: {
          field: "heigth",
          callback: (value) => {
            return value + " mm";
          },
        },
        [this.$t("ehouseDoubleCalculating.numberOfDoors")]: {
          field: "numberOfDoors",
          callback: (value) => {
            return value + " adet";
          },
        },
        [this.$t("ehouseDoubleCalculating.electricalInletOutlet")]: {
          field: "numberOfElectricalInletOutlet",
          callback: (value) => {
            return value + " adet";
          },
        },

        // Alanları - Geometric Parameters (Auxiliary Room)
        [this.$t("ehouseDoubleCalculating.auxiliaryRoomLength")]: {
          field: "lengthAuxiliary",
          callback: (value) => {
            return value + " mm";
          },
        },
        [this.$t("ehouseDoubleCalculating.auxiliaryRoomWidth")]: {
          field: "widthAuxiliary",
          callback: (value) => {
            return value + " mm";
          },
        },
        [this.$t("ehouseDoubleCalculating.auxiliaryRoomHeight")]: {
          field: "heigthAuxiliary",
          callback: (value) => {
            return value + " mm";
          },
        },
        [this.$t("ehouseDoubleCalculating.adjacentWallLength")]: {
          field: "adjecentWallLength",
          callback: (value) => {
            return value + " mm";
          },
        },
        [this.$t("ehouseDoubleCalculating.adjacentWallHeight")]: {
          field: "adjecentWallHeigth",
          callback: (value) => {
            return value + " mm";
          },
        },

        // Result Alanları - Calculation Results
        [this.$t("ehouseDoubleCalculating.heatGainMainRoomTransmission")]: {
          field: "resultRoomHeatGainWithoutSolar",
          callback: (value) => {
            return value.toFixed(2) + " kW";
          },
        },
        [this.$t("ehouseDoubleCalculating.heatGainMainRoomRadiation")]: {
          field: "resultMainRoomSolarHeatGain",
          callback: (value) => {
            return value.toFixed(2) + " kW";
          },
        },
        [this.$t("ehouseDoubleCalculating.heatGenerationMainRoom")]: {
          field: "resultMainRoomHeatGeneration",
          callback: (value) => {
            return value.toFixed(2) + " kW";
          },
        },
        [this.$t("ehouseDoubleCalculating.heatGainAuxiliaryRoomTransmission")]:
          {
            field: "resultAuxiliaryRoomHeatGainWithoutSolar",
            callback: (value) => {
              return value.toFixed(2) + " kW";
            },
          },
        [this.$t("ehouseDoubleCalculating.heatGainAuxiliaryRoomRadiation")]: {
          field: "resultAuxiliaryRoomSolarHeatGain",
          callback: (value) => {
            return value.toFixed(2) + " kW";
          },
        },
        [this.$t("ehouseDoubleCalculating.heatGenerationAuxiliaryRoom")]: {
          field: "resultAuxiliaryRoomHeatGeneration",
          callback: (value) => {
            return value.toFixed(2) + " kW";
          },
        },
        [this.$t("ehouseDoubleCalculating.freshAirHeatGain")]: {
          field: "resultCalculatedE3",
          callback: (value) => {
            return value.toFixed(2) + " kW";
          },
        },
        [this.$t("ehouseDoubleCalculating.heatGainCalculated")]: {
          field: "resultTotalThermalLoad",
          callback: (value) => {
            return value.toFixed(2) + " kW";
          },
        },
        [this.$t("ehouseDoubleCalculating.safetyFactor")]: {
          field: "resultSafetyFactor",
          callback: (value) => {
            return (value * 100).toFixed(2) + " %";
          },
        },
        [this.$t("ehouseDoubleCalculating.heatGainTotal")]: {
          field: "resultTotalRequiredCoolingCapacity",
          callback: (value) => {
            return value.toFixed(2) + " kW";
          },
        },
        [this.$t("ehouseDoubleCalculating.airFlowMainRoom")]: {
          field: "resultMainRoomVolumetricFlow",
          callback: (value) => {
            return value.toFixed(2) + " m³/h";
          },
        },
        [this.$t("ehouseDoubleCalculating.airFlowAuxiliaryRoom")]: {
          field: "resultAuxiliaryRoomVolumetricFlow",
          callback: (value) => {
            return value.toFixed(2) + " m³/h";
          },
        },
        [this.$t("ehouseDoubleCalculating.auxiliaryRoomTemperature")]: {
          field: "resultAuxiliaryRoomAverageTemperature",
          callback: (value) => {
            return value.toFixed(2) + " °C";
          },
        },
        [this.$t("ehouseDoubleCalculating.airFlowInfiltration")]: {
          field: "resultExpectedAirLeakage",
          callback: (value) => {
            return value.toFixed(2) + " m³/h";
          },
        },
        [this.$t("ehouseDoubleCalculating.condensateWaterDrainage")]: {
          field: "resultCondensationAmount",
          callback: (value) => {
            return value.toFixed(2) + " kg/h";
          },
        },

        // Result Alanları - Heat Transmission Coefficients
        [this.$t("ehouseDoubleCalculating.walls")]: {
          field: "resultAverageWallHeatTransferCoefficient",
          callback: (value) => {
            return value.toFixed(2) + " W/m²K";
          },
        },
        [this.$t("ehouseDoubleCalculating.floor")]: {
          field: "resultGroundHeatTransferCoefficient",
          callback: (value) => {
            return value.toFixed(2) + " W/m²K";
          },
        },
        [this.$t("ehouseDoubleCalculating.ceiling")]: {
          field: "resultCeilingHeatTransferCoefficient",
          callback: (value) => {
            return value.toFixed(2) + " W/m²K";
          },
        },
        [this.$t("ehouseDoubleCalculating.adjacentWalls")]: {
          field: "resultAdjacentWallHeatTransferCoefficient",
          callback: (value) => {
            return value.toFixed(2) + " W/m²K";
          },
        },
        [this.$t("ehouseDoubleCalculating.requiredDeviceCoolingCapacity")]: {
          field: "resultRequiredDeviceCoolingCapacityForRoom",
          callback: (value) => {
            return value.toFixed(2) + " kW";
          },
        },
        [this.$t("common.createdDate")]: {
          field: "createdDate",
          callback: (value) => {
            return this.$date.format(value);
          },
        },
        [this.$t("common.isActive")]: {
          field: "isActive",
          callback: (value) => {
            return value ? this.$t("common.active") : this.$t("common.passive");
          },
        },
        [this.$t("common.userInfo")]: {
          field: "user.fullname",
          callback: (value) => {
            return value;
          },
        },
      };
    },
  },
};
